export default "__VITE_ASSET__pl_BNOW6__"